import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import MyContext from "./MyContext";

const PrivateAdminRoute = ({ children }) => {
  const { adminAuth } = useContext(MyContext);
  return adminAuth ? children : <Navigate to="/admin-login" replace />;
};

export default PrivateAdminRoute;
